<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-chart"></i>
                            <span>{{$t('invoice_details.title')}}</span>
                        </h2>
                        <div @click.prevent="editInvoice" class="panel_header__action">
                            <i class="panel_header__action__icon icons icon-pencil"></i>
                            <a class="button--link">{{$t('invoice_details.edit')}}</a>
                        </div>
                    </div>
                    <div class="panel__body">
                        <div v-if="loading">
                            <div class="spinner"></div>
                        </div>

                        <template v-else>
                            <invoice-items-table :items="invoice.rows" />
                            <div class="totals">
                                <table class="table__totals">
                                    <tr>
                                        <td>{{$t('invoice_details.total')}}:</td>
                                        <td>{{invoice.total | toCurrency}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('invoice_details.vat')}}:</td>
                                        <td>{{invoice.vat | toCurrency}}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>{{$t('invoice_details.total_with_vat')}}:</strong></td>
                                        <td>{{invoice.total_with_vat | toCurrency}}</td>
                                    </tr>
                                </table>
                            </div>
                        </template>
                    </div>
                    <invoice-modal />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.totals {
    overflow: auto;
}

.table__totals
{
    float: right;
    text-align: right;

    td
    {
        padding: 1.2rem;
    }
}

</style>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import InvoiceItemsTable from '@/components/tables/invoice-details/InvoiceItemsTable';
    import InvoiceModal from '@/components/modals/dashboard/InvoiceModal';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';
    import { GET_INVOICE } from '@/store/modules/invoice';


    @Component({
        components: {
            InvoiceItemsTable,
            InvoiceModal,
        }
    })
    export default class InvoiceDetails extends Vue {
        name = 'invoice-details';

        created() {
            const trajectoryId = +this.$route.params.trajectoryId;
            this.$store.dispatch(GET_TRAJECTORY, { id: trajectoryId })
                .catch(
                    err => {
                        if (err.status === 404) {
                            this.$notify.error(this.$t('notify.trajectory.not_found', { id: trajectoryId }));
                            this.$router.replace({name: 'page_not_found'});
                        }
                    });

            const invoiceId = +this.$route.params.invoiceId;
            this.$store.dispatch(GET_INVOICE, { trajectoryId, invoiceId })
                .catch(
                    err => {
                        if (err.status === 404) {
                            this.$notify.error(this.$t('notify.invoice.not_found', { id: invoiceId }));
                            this.$router.replace({name: 'page_not_found'});
                        }
                    });
        }

        get loading() {
            return this.$store.state.trajectory.loading || this.$store.state.invoice.loading;
        }

        get invoice() {
            return this.$store.state.invoice.invoice;
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        editInvoice() {
            this.$modal.show('invoice-modal', { invoice: this.invoice });
        }

    }
</script>



// WEBPACK FOOTER //
// src/pages/InvoiceDetails.vue